/**** mgt.RaspVariants */
import moment       from 'moment';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'RaspVariants',
  title: 'Варианты расписаний',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    route: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Routes',
      index: 'route_id',
      fields: ['route_short_name'],
      format: (elem: any) => elem['route_short_name'],
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'route_id',
      title: 'Маршрут',
      type: 'number',
      required: true,
      connection: 'route',
    },
    {
      name: 'dow',
      title: 'День недели, по которому работает транспорт',
      type: 'list',
      required: true,
      values: [
        { key: null, value: 'Любой день' },
        { key: 0, value: 'Воскресенье' },
        { key: 1, value: 'Понедельник' },
        { key: 2, value: 'Вторник' },
        { key: 3, value: 'Среда' },
        { key: 4, value: 'Четверг' },
        { key: 5, value: 'Пятница' },
        { key: 6, value: 'Суббота' },
      ],
    },
    {
      name: 'srv_id',
      title: 'ID варианта расписания',
      type: 'number',
      required: true
    },
    {
      name: 'startdate',
      title: 'Дата ввода в действие',
      type: 'date',
      required: true,
    },
    {
      name: 'enddate',
      title: 'Дата окончания действия',
      type: 'date',
      required: false,
      validate: (value: any, row: any) => {
        return !row['startdate'] || !value || moment(row['startdate']) < moment(value);
      },
      validateError: 'Дата окончания не может быть меньше даты ввода'
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    },
  ],
  newTemplate: {
    id: null,
    route_id: null,
    dow: null,
    startdate: null,
    enddate: null,
    do_not_update: true,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'service_id',
        field: 'srv_id',
      }, {
        title: 'route_id',
        field: 'route_id',
      },
      {
        title: 'monday',
        field: 'dow1',
      },
      {
        title: 'tuesday',
        field: 'dow2',
      },
      {
        title: 'wednesday',
        field: 'dow3',
      },
      {
        title: 'thursday',
        field: 'dow4',
      },
      {
        title: 'friday',
        field: 'dow5',
      },
      {
        title: 'saturday',
        field: 'dow6',
      },
      {
        title: 'sunday',
        field: 'dow0',
      },
      {
        title: 'service_date_start',
        field: 'startdate',
      },
      {
        title: 'service_date_end',
        field: 'enddate',
      },
    ],
    example: `1;1;1;1;1;1;1;0;0;2020-01-01;2030-01-01`,
    customInsert: 'function (elem, nextIdFunc) { \
      let sql =  `DELETE FROM mgt."RaspVariants" WHERE srv_id=${elem.srv_id};`; \
      for(let i=0;i<7;++i){ \
        if(elem[`dow${(i+1)%7}`]===`1`){\
          const next_id = nextIdFunc();\
          sql += `INSERT INTO mgt."RaspVariants"(srv_id, id, route_id, dow, startdate, enddate, num, update_date) VALUES (${elem.srv_id}, ${next_id}, ${elem.route_id}, ${(i+1)%7},\'${elem.startdate}\',\'${elem.enddate}\', ${next_id}, now());` \
        } \
      }\
      return sql; \
    }'
    // insertOnly: true,
  },
  export: {
    fields: [
      {
        name: 'route_id',
        title: 'Маршрут',
        connectionGetField: 'route_short_name'
      },
      {
        name: 'vehicle_type',
        title: 'Тип ТС',
        connection: 'vehicle_type',
        connectionField: 'route_id',
      },
      {
        name: 'dow',
        title: 'День недели, по которому работает транспорт',
        format: {
          fields: ['dow'],
          template: '%1',
          values: {
            'null': 'Любой день',
            '1': 'Понедельник',
            '2': 'Вторник',
            '3': 'Среда',
            '4': 'Четверг',
            '5': 'Пятница',
            '6': 'Суббота',
            '0': 'Воскресенье',
          }
        }
      },
      {
        name: 'srv_id',
        title: 'ID варианта расписания',
      },
      {
        name: 'startdate',
        title: 'Дата ввода в действие',
        type: 'date',
      },
      {
        name: 'enddate',
        title: 'Дата окончания действия',
        type: 'date',
      },
    ],
    connections: {
      vehicle_type: {
        index: 'route_id',
        customsql:
          `
            SELECT
                v.route_type
            FROM
                mgt."RaspVariants" rv
            INNER JOIN
                mgt."Routes" r on rv.route_id = r.route_id
            INNER JOIN
                mgt."Vehicle_Task" vt ON rv.id = vt."RaspVariant_id"
            INNER JOIN
                mgt."Vehicle" v ON vt.vehicle_id = v.vehicle_id
          `,
      },
    }
  }
};

export default config;
